export default __webpack_public_path__ + "img/ea4f7e96e78b998a15f59a7d0bac9857.svg";